import {createSvgIcon} from '../create-svg-icon';

export const PendingIcon = createSvgIcon(
  [<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" key="0" />,<circle cx="7" cy="12" r="1.5" key="1" />,<circle cx="12" cy="12" r="1.5" key="2" />,<circle cx="17" cy="12" r="1.5" key="3" />,]
, 'PendingOutlined');
